import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Curriculum from './components/Curriculum';
import Admission from './components/Admission';
import Timeline from './components/Timeline';
import Partners from './components/Partners';
import LogoScroll from './components/LogoScroll';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Curriculum />
      <Admission />
      <Timeline />
      <Partners />
      <LogoScroll />
      <Contact />
      <Footer />
    </div>
  );
}